import React, { Ref } from 'react';
import DonutChartComponent from './DonutChart.component';
import BarChartComponent from './BarChart.component';
import HorizontalBarChartComponent from './HorizontalBarChart.component';
import { chartVarieties } from '../../constants/report.constant';

export interface ChartDataItem {
  label: string;
  value?: number;
}

export interface MultipleChartDataItem {
  label: string;
  field: string | undefined;
}

export interface TypedChartProps {
  data: ChartDataItem[];
  onClick?: (dataItem: ChartDataItem, key?: string | undefined) => void;
  onMultipleClick?: (
    dataItem: [MultipleChartDataItem, MultipleChartDataItem],
  ) => void;
  showLabels?: boolean;
  legendPortalRef?: Ref<HTMLElement>;
  isAnimationActive?: boolean;
  stackBlockNames?: string[];
  commonCount?: number;
  showLegend?: boolean;
  showTextTooltip?: boolean;
}

export interface ChartProps extends TypedChartProps {
  type: string;
}

const ChartComponent = ({ type, ...props }: ChartProps) => {
  if (!props.data) return null;

  switch (type) {
    case chartVarieties.DONUT:
      return <DonutChartComponent {...props} />;
    case chartVarieties.BAR:
      return <BarChartComponent {...props} />;
    case chartVarieties.HORIZONTAL:
      return <HorizontalBarChartComponent {...props} />;
    default:
      return null;
  }
};

export default ChartComponent;
